export const FISH_SPECIES = [
  { value: "mackerel", label: "Mackerel" },
  { value: "cod", label: "Cod" },
  { value: "haddock", label: "Haddock" },
  { value: "bass", label: "Bass" },
  { value: "trout", label: "Trout" },
];

export const idealTempRanges = {
  cod: { min: 4, max: 10 }, // Cod prefer colder waters, especially in the North Sea.
  haddock: { min: 4, max: 10 }, // Similar to cod, haddock thrive in colder temperatures.
  mackerel: { min: 8, max: 14 }, // Mackerel prefer slightly warmer waters, especially in summer.
  bass: { min: 10, max: 20 }, // Bass can be found in warmer coastal areas around the UK.
  trout: { min: 7, max: 14 }, // Trout, especially in freshwater, prefer moderate temperatures.
};

export const moonScoreMapping = {
  full: 30,
  new: 30,
  "waxing crescent": 20,
  "waning crescent": 20,
  "first quarter": 15,
  "last quarter": 15,
  "waxing gibbous": 10,
  "waning gibbous": 10,
};

export const troutMoonScoreAdjustment = {
  full: -10,
  new: -10,
  "waxing crescent": -5,
  "waning crescent": -5,
  "first quarter": -5,
  "last quarter": -5,
  "waxing gibbous": -5,
  "waning gibbous": -5,
};
